export default "__VITE_ASSET__CVNVUxOr__"